import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './SamePageReloadHandler.css';

/**
 * Компонент для прокрутки страницы вверх при навигации
 * Показывает анимацию загрузки при переходе между страницами
 */
const SamePageReloadHandler = () => {
  const location = useLocation();

  useEffect(() => {
    // Прокрутка вверх при каждом изменении маршрута
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant' // Мгновенная прокрутка без анимации
    });

    // Показываем анимацию загрузки
    let overlay = document.querySelector('.page-transition-overlay');
    
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = 'page-transition-overlay';
      overlay.innerHTML = '<div class="page-transition-spinner"></div>';
      document.body.appendChild(overlay);
    }

    // Показываем оверлей
    overlay.classList.add('visible');

    // Скрываем оверлей через короткое время
    const timer = setTimeout(() => {
      overlay.classList.remove('visible');
    }, 400);

    return () => {
      clearTimeout(timer);
    };
  }, [location.pathname]); // Срабатывает при каждом изменении пути

  return null;
};

export default SamePageReloadHandler;
